import { JobItem, JobItemStatus, JobItemType } from 'scenes/jobs/types';
import { format } from 'date-fns';
import { ResponseJobItem } from 'services/types';
import { DATE_DD_MON_YEAR, DATE_DD_MON_YEAR_HH_MM } from 'constants/dateFormat';
import { generateDurationFromStrings, getDateFormatted } from 'shared/utils';

export const mapResponseJobToJobItem = (
  responseJob: Partial<ResponseJobItem>
): JobItem => {
  const taskId = responseJob.taskId ?? 'Not Identifiable';
  const name = responseJob?.label ?? 'UnNamed';
  const description = undefined; // TODO: get description from the report Id
  const type: JobItemType = 'Custom'; // TODO: remove hardcoded value
  const errors = responseJob?.taskErrorMessage; // TODO: remove hardcoded value
  const status = responseJob?.taskStatus as JobItemStatus;
  const progressRate = 0.5; // TODO: remove hardcoded value

  const valuationDate = responseJob?.valuationDate
    ? format(new Date(responseJob.valuationDate), DATE_DD_MON_YEAR)
    : 'No valuation';

  const started = getDateFormatted({
    date: responseJob?.taskStartTime,
    formatString: DATE_DD_MON_YEAR_HH_MM,
  });

  const duration = generateDurationFromStrings({
    start: responseJob?.taskStartTime,
    end: responseJob?.taskEndTime,
  });

  return {
    taskId,
    name,
    description,
    type,
    valuationDate,
    started,
    duration,
    status,
    progressRate,
    errors,
  };
};
